import React, { useEffect, useState } from "react";
import "../PlayerComparison/playercomparison.css";
import { postData } from "../../services/api";
import IApiResponse from "../../types/IApiResponse";
import apiUrls from "../../config/apiUrls";
import handleApiResponse from "../../utils/handleApiResponse";
import LabelText from "../../ui/LabelText";
import { useNotification } from "../../contexts/NotificationContext";
import { useLocation, useParams } from "react-router-dom";
import { useLoading } from "../../contexts/LoadingContext";
import { IClubComparisonData } from "../../types/ClubComparison";
import { useSidebar } from "../../contexts/SidebarContext";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SecondaryButton from "../../ui/SecondaryButton";
import { MainContainer } from "../Contents/Contents.element";
import PageHeader from "../../layout/PageHeader";
import ClubComparisonTableContent from "./ClubComparisonTableContent";
import { IClubFilter, IPossibleClubFilter, PlotClubFilters } from "./ClubPlotUtils";
import { ClubPlotComparison } from "./ClubPlotComarison";
import { useAuth } from '../../contexts/AuthContext';
import ClubSortlistGameModel from "./ClubSortlistGameModel";
import CustomDropdown from "../../ui/CustomDropdown";

const ClubComparisonTool = () => {

    const { startLoading, stopLoading, loading } = useLoading();
    const { userId } = useParams<{ userId: string }>();
    const { userData } = useAuth();
    const location = useLocation();
    const { showNotification, hideNotification, displayNotification, setDisplayNotification, notificationContent, setNotificationContent } =
      useNotification();
    const { isOpen, toggleSubSidebar, subMenuOpen, setActiveItemId, toggleDrawer, drawerState, isBlurred, setIsBlurred } = useSidebar();
    const { teamIds, isFromSortList } = location.state || [];
    const [activeContent, setActiveContent] = useState("table");
    const [clubComparisonTableData, setClubComparisonTableData] = useState<IClubComparisonData[]>([]);
    const [sortKey, setSortKey] = useState<IPossibleClubFilter>("teamTotalRevenue");
    const [selectedPlotFilterOption, setSelectedPlotFilterOption] = useState<"up" | "across" | "dotSize" | undefined>(undefined);
    const [acrossSortDirection, setAcrossSortDirection] = useState<"inc" | "dec">("inc");
    const [upSortDirection, setUpSortDirection] = useState<"asc" | "desc">("desc");
    const [plotFilters, setPlotFilters] = useState<IClubFilter>({
      up: sortKey,
      across: null,
      dotSize: null,
    });
    const currentYear = new Date().getFullYear();
    const startYear = 2008;
    const endYear = currentYear + 1;
    const options: { value: string; label: string }[] = [];
    for (let year = endYear; year >= startYear + 1; year--) {
      const season = `${year - 1}/${year}`;
      options.push({ value: season, label: season });
    }
    const defaultSelectedValue = options[1]?.value || "";
    const [selectedSeasonName , setSelectedSeasonName] = useState<string>(defaultSelectedValue);


      const fetchClubComparisondata = async (filteredPlayerIds: number[], seasonName: string) => {
      try {
        startLoading();
        const requestParameters = {
          teamId: filteredPlayerIds,
          seasonName: seasonName,
          userId: userData,
        };
        const response: IApiResponse<IClubComparisonData[]> = await postData(apiUrls.TeamsComparison, requestParameters);
        handleApiResponse(
          response,
          (clubComparisonData) => {
            stopLoading();
            if (response.data && response.data.length > 0) {
              setClubComparisonTableData(response.data);
            } else {
              setClubComparisonTableData([]);
            }
          },
          (error) => {
            stopLoading();
            setClubComparisonTableData([]);
            console.error("Error in API response:", error);
          }
        );
      } catch (error) {
        stopLoading();
        setClubComparisonTableData([]);
        console.error("Exception while fetching club comparison data:", error);
      }
    };

    useEffect(() => {
      const storedRemovePlayerIds: number[] = JSON.parse(localStorage.getItem("removedclubIds") || "[]");
      const filteredPlayerIds = teamIds?.filter((id: number) => !storedRemovePlayerIds.includes(id));
      fetchClubComparisondata(storedRemovePlayerIds.length > 0 ? filteredPlayerIds : teamIds , selectedSeasonName!);
    }, [selectedSeasonName]);

    const handleSeasonChange = (seasonName : string) =>{
        setSelectedSeasonName(seasonName)
    }

  return (
    <MainContainer isBlurred={isBlurred!} className={"main-container player-detail-page"}>
      <PageHeader pageTitle={isFromSortList ? "Club shortlist" : "Club Comparison"} />
      <div className="player-comparison-content player-comparison-content-without-scroll">
        <div className="comparison-tool-btns">
          <div className="comparison-tool-btns-view">
            <SecondaryButton
              iconType="table"
              label="Table"
              isSelected={activeContent === "table"}
              onClick={() => setActiveContent("table")}
            />
            <SecondaryButton iconType="plot" label="Plot" isSelected={activeContent === "plot"} onClick={() => setActiveContent("plot")} />
            <SecondaryButton label="Game model" isSelected={activeContent === "gameModel"} onClick={() => setActiveContent("gameModel")} />  
               {/* {activeContent === "table" && ( */}
              <div>
                <CustomDropdown
                  placeholder="SEASON"
                  options={options}
                  onChange={handleSeasonChange}
                  deafaultSelected={`${defaultSelectedValue}`} // select last year (current year + 1)
                  fromAttributes={false}
                  isDisplaySearchInput={false}
                />
              </div>
              {/* )} */}
          </div>
        
          {activeContent === "plot" && (
            <PlotClubFilters
              clubPlotFilters={plotFilters}
              setSelectedPlotFilterOption={setSelectedPlotFilterOption}
              selectedPlotFilterOption={selectedPlotFilterOption}
              setPlotFilters={setPlotFilters}
              acrossSortDirection={acrossSortDirection}
              setAcrossSortDirection={setAcrossSortDirection}
              upSortDirection={upSortDirection}
              setUpSortDirection={setUpSortDirection}
            />
          )}
        </div>
        <div className="comparison-tool-content">
          {activeContent === "table" && (
            <div className="content-table">
              {/* <PlayerComparisonTableContent
                sortKey={sortKey}
                setSortKey={setSortKey}
                tableData={playerComparisonTableData}
                isFormSortList={isFromSortList ? isFromSortList : FromSortListPage}
                benchmarkID={benchMarkPlayerId}
              /> */}
              <ClubComparisonTableContent tableData={clubComparisonTableData!} isFromSortList={isFromSortList} selectedSeasonName={selectedSeasonName}/>
            </div>
          )}
          {activeContent === "plot" && (
            <div className="content-plot">
              <ClubPlotComparison
                clubComparisonData={clubComparisonTableData}
                clubPlotFilters={plotFilters}
                isFormSortList={isFromSortList}
                acrossSortDirection={acrossSortDirection}
                upSortDirection={upSortDirection}
              />
            </div>
          )}
          {activeContent === "gameModel" && (
            <ClubSortlistGameModel clubComparisonData={clubComparisonTableData}/>
          )}
        </div>
      </div>
      {/* {displayNotification &&
                <PWNotification message={notificationContent} setIsNotification={() => setDisplayNotification(false)} isDisplayCloseIcon={false}
                    className='player-filter-notification comparison-notification' />} */}
    </MainContainer>
  );
};

export default ClubComparisonTool;
